// @flow

import React, { PureComponent } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import moment from 'moment';
import styled from 'styled-components';
import type { RouterHistory } from 'react-router';
import { i18n } from 'shared/utils';
import Table from 'shared/components/common/Table';
import ReturnOrderStatusPill from 'shared/components/common/Pill/ReturnOrderStatusPill';

const Wrapper = styled.div`
  padding: 0 24px;
`;

type Props = {
  history: RouterHistory,
  returnOrderEdges: Array<Object>,
  onCreateNew: () => void,
};

class ReturnsTable extends PureComponent<Props> {
  handleRowClick = (rowData: Object) => {
    const { history } = this.props;
    history.push(`/return/${rowData.node.id}`);
  };

  getColumns = () => {
    const columns = [
      {
        Header: i18n.t('RMA #'),
        accessor: 'node.returnNumber',
        width: 130,
      },
      {
        Header: i18n.t('Order #'),
        accessor: 'node.order.orderNumber',
        width: 120,
        Cell: ({ value }: *) => value || '—',
      },
      {
        Header: i18n.t('Customer'),
        accessor: 'node.customer.name',
        minWidth: 160,
      },
      {
        Header: i18n.t('Status'),
        accessor: 'node.status',
        width: 120,
        Cell: ({ value }: *) => <ReturnOrderStatusPill status={value} />,
      },
      {
        Header: i18n.t('Type'),
        accessor: 'node.returnType',
        width: 110,
        Cell: ({ value }: *) =>
          value ? value.replace(/_/g, ' ') : '—',
      },
      {
        Header: i18n.t('Reason'),
        accessor: 'node.reason',
        width: 140,
        Cell: ({ value }: *) =>
          value ? value.replace(/_/g, ' ') : '—',
      },
      {
        Header: i18n.t('Created'),
        accessor: 'node.createdAt',
        width: 120,
        Cell: ({ value }: *) => moment(value).format('MM/DD/YYYY'),
      },
    ];

    return columns;
  };

  render() {
    const { returnOrderEdges } = this.props;

    if (!returnOrderEdges || returnOrderEdges.length === 0) {
      return null;
    }

    return (
      <Wrapper>
        <Table
          data={returnOrderEdges}
          columns={this.getColumns()}
          onRowClick={this.handleRowClick}
        />
      </Wrapper>
    );
  }
}

export default createFragmentContainer(ReturnsTable, {
  returnOrderEdges: graphql`
    fragment ReturnsTable_returnOrderEdges on ReturnOrderEdge @relay(plural: true) {
      node {
        id
        returnNumber
        status
        returnType
        reason
        order {
          id
          orderNumber
        }
        customer {
          id
          name
        }
        createdAt
        updatedAt
      }
    }
  `,
});
